// Module
var code = "<div class=\"form-group row\">\n    <label ng-show=\"vm.label && vm.label.length > 0\" class=\"col-sm-4 control-label\">{{vm.label | translate}}:</label>\n    <div class=\"col-sm-8\">\n        <ng-transclude></ng-transclude>\n    </div>\n</div>";
// Exports
module.exports = code;